module.exports = __webpack_public_path__ + "img/BPM_DM.b4441c6f.png";